import { render, staticRenderFns } from "./CourierAccounts.vue?vue&type=template&id=c1834dc8"
import script from "./CourierAccounts.vue?vue&type=script&lang=js"
export * from "./CourierAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports